"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _ListItem = _interopRequireDefault(require("./ListItem"));
var _excluded = ["classes", "className", "theme"];
/*:: import { type Node } from 'react';*/
/*:: import { type InjectSheetProvidedProps, type ThemeType } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      alignItems: 'flex-end',
      borderTop: 'none',
      color: theme.colors.pebbleGrey,
      padding: '1rem 0 .5rem',
      margin: '1rem 0 .5rem',
      borderBottom: "1px solid ".concat(theme.colors.lightGrey)
    }
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  children?: Node
};*/
var ListItemGroupHeader = function ListItemGroupHeader(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/ /*: Node*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props));
};
ListItemGroupHeader.displayName = 'ListItemGroupHeader';
var _default = exports.default = (0, _injectSheet.default)(Style)(ListItemGroupHeader);
//# sourceMappingURL=ListItemGroupHeader.js.map